import 'phaser'
import { createId } from '../main/common'
import { frameInfo } from '../main/frameInfo-sidecar'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { IRawFrameInfo } from '../main/frameInfo'

export interface IHealthBar extends IEntity {
  image: Phaser.GameObjects.Image
  imageBackground: Phaser.GameObjects.Image
  percent: number
}

const objs: IHealthBar[] = []
export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

let fw = 18
let fh = 3
let percentages = 16
const framesBackground = frameInfo.fiRaw(4, 65, 2 + 2 + fh, fw, fh)
const framesPercentage: IRawFrameInfo[] = []
for (let i = 0; i < percentages; i++) {
  let fi = frameInfo.fiRaw(4, 65, 2, 1 + i, fh)
  fi.scale = 0.5
  framesPercentage.push(fi)
}

export function create(): IHealthBar {
  let id = createId()

  let imageBackground = spriteMap.createImageFromRawFrameInfo(
    layers.getLayers().main,
    framesBackground,
    0,
    0,
    2,
  )

  let image = spriteMap.createImageFromRawFrameInfo(
    layers.getLayers().main,
    framesPercentage[5],
    0,
    0,
    2,
  )

  let obj: IHealthBar = {
    eType: 'health-bar',
    id,

    image,
    imageBackground,
    isDead: false,
    percent: 0.5,
  }
  objs.push(obj)

  return obj
}

export function kill(obj: IHealthBar) {
  obj.isDead = true
  obj.image.tint = 0xccc
}

export function attach(obj: IHealthBar, x: number, y: number, percent: number) {
  obj.imageBackground.x = x
  obj.imageBackground.y = y

  let f = Math.round(percentages * percent)
  if (f >= percentages) {
    f = percentages - 1
  }
  if (f < 0) {
    f = 0
  }

  obj.image.x = x - (percentages - f)
  obj.image.y = y

  spriteMap.setRawFrame(obj.image, framesPercentage[f])

  if (percent >= 1) {
    obj.image.visible = false
    obj.imageBackground.visible = false
  } else {
    obj.image.visible = true
    obj.imageBackground.visible = true
  }

  // set percentage
}

export function updateAll() {
  objs.forEach((c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
    c.imageBackground.destroy()
  })
}
function update(obj: IHealthBar) {}
